<template>
	<div id="third">
		<header>
			<img src="../assets/logo.svg">
			<router-link to="/"><div class="subtitle">
			<span>{{brandName}}</span>
			<span>  >  </span>
			</div></router-link>
		</header>

		  <div class="content" :style="height">
			<iframe :src="link"></iframe>
			<div class="seclect third">
				<h2>Which retail channel you want to select?</h2>
				<p class="third-sub">请选择一种零售渠道进行铺货。目标营销区域内的每种零售终端数量已标注在括号中。<span>Please select one retail channel. You may find the number of each retail channel in brackets.</span></p>
        <div class="brand">

	<div class="radioBox" v-for="(item,index) in radioVal" >
     <input type="radio" @click="changeColor(index)"  :name="item.val"  :id="'checkbox_b'+index" class="checkbox1" :value="item.val" v-model="picked" /><label clickMusic='true' :for="'checkbox_b'+index "></label><label  clickMusic='true' :for="'checkbox_b'+index ">{{item.text+ '('+areaNum[index]+'家)'}}</label>
	</div>



        </div>
		</div>


		</div>
      <footer>
        <div>
         <div class="prev"><router-link to="/second2"> << prev </router-link></div>
         <div class="step"><span>2/4</span></div>
         <div class="continue"><span><button clickMusic='true' @click="validate">Continue</button></span></div>
        </div>
      </footer>

		<alert v-if="show" @showbox="toshow" :show="show" :msg="'You must select one retail channel'"></alert>

	</div>

</template>
<style type="text/css">

#third	.content .third h2{padding: 5% 5% 2% 10%}
#third	.content .third p.third-sub{padding: 0% 5% 2% 10%;font-size: 18px;color: #535b68}
#third	.content .third p.third-sub span{display: block;font-size: 14px;padding-top: 10px;}
.radioBox{background: #ffffff;border-radius:24px;padding: 2% 5%;width: 80%;margin: 5% 0;    border: 1px solid #eee;color: #717780; }

    label{cursor: pointer;}


.checkbox1 {
        display: none;
    }
    .checkbox1 + label {
        display: inline-block;
        margin-right: 5px;
        color: #FFF;
        font-size: 1.7em;
        content: ' ';
        border-radius: 100px;
        width: 20px;
        position: relative;
        height: 20px;
        vertical-align: text-bottom;
        border:1px solid #eee;
    }
    .checkbox1 + label:before {
    content: ' ';
    border-radius: 100px;
    width: 6px;
    position: relative;
    top: 7px;
    right: -7px;
    /* z-index: 999; */
    -webkit-box-shadow: inset 0px 16px 40px #FFF;
    box-shadow: inset 0px 16px 40px #FFF;
    height: 6px;
    display: none;
    /* border: 4px solid #259656; */
    }

    .checkbox1:checked + label:before {
        display: block;
    }

    .checkbox1:checked + label{
    	background: #004976;
    	border-color:#fff;
    	color: #fff
    }




</style>

<script>
import Alert from './alert.vue';
import link from '../assets/link';

export default {
   name:"second",
    components: {
       "alert":Alert
    },
   data(){
   	return{
   		msg:"第二页",
   		show:false,
   		brandName:"",
   		link:'',
      areaNum:'',
   		height:{
   			height:""
   		},
   		picked:"",
   		radioVal:[
   		{text:"大卖场 hypermarket",val:"bigStore"},
   		{text:"便利店 convenient store",val:"convenienceStore"},
   		{text:"屈臣氏 Watsons",val:"Watsons"}
   		]

   	}
   },
   methods:{

       toshow(show){
          this.show = show;
	   },
   	  readData(){
   	  	this.brandName = sessionStorage.getItem("BrandName");
   	  	this.showLink()
   	  },
       showLink(){
           for(let a of link.brand){
               if(a.name == this.brandName){
                   this.link=a.link[2];
                   this.areaNum= a.area[0]
               }
           }
       },
   	  changeColor(index){
	  var id = 'checkbox_b'+index
	  for(let a = 0;a<3;a++){
			let g = document.getElementsByClassName('radioBox')[a]
			  g.style.background= "#fff";
			  g.lastChild.style.color ="#717780"
	  }

      var b = document.getElementsByClassName('radioBox')[index]
      b.style.background= "#004976";
      b.lastChild.style.color ="#fff";

     var h =document.getElementById(id)

		if (window.sessionStorage) {
   	  		sessionStorage.setItem("area", h.value);
   	  	 }

   	  },
      validate(){
        if(this.picked== ""){
            this.show  = true
        }else{
          this.show  = false;
          this.$router.push('fourth')
        }
      }

   }  ,
    created() {
    	this.height.height=window.innerHeight-120+'px'
      	this.readData();
    },
    mounted() {

    }



}

</script>



// WEBPACK FOOTER //
// src/components/third.vue